module.exports = __webpack_public_path__ + "5dfdbaf01e6250f5599dde114d3681e5.svg";